import React from "react";
import siteConfig from "../config/siteConfig";
import "../css/customer-care.scss";

function Accessibility() {
  return (
    <main className="policy-page customer-care">
      <header>
        <p className="eyebrow">Our commitment</p>
        <h1>Accessibility</h1>
        <p>irtradeco aims to provide a clear and usable shopping experience for as many people as possible.</p>
        <small>Last reviewed: 14 September 2026</small>
      </header>
      <article className="policy-copy">
        <section><h2>How the site is designed</h2><p>The storefront uses semantic headings, labelled form controls, keyboard-accessible navigation, visible focus behaviour, alternative text and reduced-motion preferences where appropriate.</p></section>
        <section><h2>Known limitations</h2><p>Accessibility is an ongoing process. Third-party payment or delivery services connected in the future may have their own interfaces and accessibility support.</p></section>
        <section><h2>Feedback &amp; assistance</h2><p>If a page or feature is difficult to use, email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>. Include the page address, the task you were trying to complete and any assistive technology used.</p></section>
        <section><h2>Alternative support</h2><p>Our team can provide product, delivery and policy information in an alternative format and help complete non-payment parts of the shopping process.</p></section>
      </article>
    </main>
  );
}

export default Accessibility;
